import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { ConstantsService } from '../constant/constants.service';
import { ImportResponse } from 'src/app/shared/models/api-response/import-response';
import { GenericCrudService } from '../generic-crud.service';
import { Prestation } from 'src/app/shared/models/prestation';
import { HttpHeaders, HttpParams } from '@angular/common/http';

@Injectable({
	providedIn: 'root'
})
export class PrestationService {
	constructor(
		private appConstants: ConstantsService,
		private genericCrudService: GenericCrudService
	) {}

	getAllPrestation(): Observable<Prestation[]> {
		return this.genericCrudService.genericGetAPIData(
			`${this.appConstants.prestationUrl}/all`,
			'getAllPrestation'
		);
	}

	getPrestationByBeneficiaire(beneficiaireId: number): Observable<Prestation[]> {
		return this.genericCrudService.genericGetAPIData(
			`${this.appConstants.prestationUrl}/getByBeneficiaire/${beneficiaireId}`,
			'getPrestationByBeneficiaire'
		);
	}

	importPrestation(file: File): Observable<ImportResponse> {
		const formData: FormData = new FormData();
		formData.append('file', file, 'prestation.csv');
		return this.genericCrudService.genericPostDataToAPI(
			`${this.appConstants.prestationUrl}/import`,
			`importPrestation`,
			formData
		);
	}

	getPrestationById(id: number): Observable<Prestation> {
		return this.genericCrudService.genericGetAPIData(
			`${this.appConstants.prestationUrl}/get/${id}`,
			'getPrestationById'
		);
	}

	updatePrestation(prestation: Prestation): Observable<Prestation> {
		return this.genericCrudService.genericPutDataToAPI(
			`${this.appConstants.prestationUrl}/update/${prestation.id}`,
			'updatePrestation',
			prestation
		);
	}

	addPrestation(prestation: Prestation): Observable<void> {
		return this.genericCrudService.genericPostDataToAPI(
			`${this.appConstants.prestationUrl}/add`,
			'addPrestation',
			prestation
		);
	}

	deletePrestation(prestationId: number): Observable<void> {
		return this.genericCrudService.genericDeleteAPIDataByID(
			`${this.appConstants.prestationUrl}/delete/${prestationId}`,
			`deletePrestation`
		);
	}

	getPrestationByIdQualification(id: number): Observable<Prestation[]> {
		return this.genericCrudService.genericGetAPIData(
			`${this.appConstants.prestationUrl}/getByIdQualification/${id}`,
			'getPrestationByIdQualification'
		);
	}

	getPrestationByServiceAndRegion(serviceId: number, regionId: number): Observable<Prestation[]> {
		return this.genericCrudService.genericGetAPIData(
			`${this.appConstants.prestationUrl}/getByServiceAndRegion/${serviceId}/${regionId}`,
			'getByServiceAndRegion'
		);
	}

	getPrestationByServiceAndRegionAndDates(serviceId: number, regionId: number, dateDebut: string, dateFin: string): Observable<Prestation[]> {
		return this.genericCrudService.genericGetAPIData(
			`${this.appConstants.prestationUrl}/getByServiceAndRegionAndDates/${serviceId}/${regionId}/${dateDebut}/${dateFin}`,
			'getByServiceAndRegionAndDates'
		);
	}

	getPrestationByServiceAndDates(serviceId: number, dateDebut: string, dateFin: string): Observable<Prestation[]> {
		return this.genericCrudService.genericGetAPIData(
			`${this.appConstants.prestationUrl}/getByServiceAndDates/${serviceId}/${dateDebut}/${dateFin}`,
			'getByServiceAndDates'
		);
	}

	getPrestationByDates(dateDebut: string, dateFin: string): Observable<Prestation[]> {
		return this.genericCrudService.genericGetAPIData(
			`${this.appConstants.prestationUrl}/getByDates/${dateDebut}/${dateFin}`,
			'getByDates'
		);
	}

	getPrestationByTypeHandicapAndDates(typeHandicapId: number, dateDebut: string, dateFin: string): Observable<Prestation[]> {
		return this.genericCrudService.genericGetAPIData(
			`${this.appConstants.prestationUrl}/getByTypeHandicapAndDates/${typeHandicapId}/${dateDebut}/${dateFin}`,
			'getByTypeHandicapAndDates'
		);
	}

	getPrestationByServiceAndRegionPagination(serviceId: number, regionId: number, currentPage: number, itemsPerPage: number, selectedStatus?: string[],
		selectedType?: string[], searchedInput?: string): Observable<any> {
			const statusStr = selectedStatus.length ? selectedStatus.join(',') : 'ALL';
  			const typeStr = selectedType.length ? selectedType.join(',') : 'ALL';
			const inputSearchStr = searchedInput.length ? searchedInput : 'NotDefined';
			return this.genericCrudService.genericGetAPIData(
				`${this.appConstants.prestationUrl}/getByServiceAndRegionPagination/${serviceId}/${regionId}/${currentPage}/${itemsPerPage}/${statusStr}/${typeStr}/${inputSearchStr}`,
				'getByServiceAndRegionPagination'
		);
	}

	getPrestationByBonCommande(bonCommandeId: number): Observable<Prestation[]> {
		return this.genericCrudService.genericGetAPIData(
			`${this.appConstants.prestationUrl}/getByBonCommande/${bonCommandeId}`,
			'getByBonCommande'
		);
	}

	getPrestationByBonCommandeDashboard(bonCommandeId: number): Observable<Prestation[]> {
		return this.genericCrudService.genericGetAPIData(
			`${this.appConstants.prestationUrl}/getByBonCommandeDashboard/${bonCommandeId}`,
			'getByBonCommandeDashboard'
		);
	}

	getPrestationByIntervenant(intervenantId: number): Observable<Prestation[]> {
		return this.genericCrudService.genericGetAPIData(
			`${this.appConstants.prestationUrl}/getByIntervenant/${intervenantId}`,
			'getByIntervenant'
		);
	}

	/**
	 * Supprime une liste de missionRequest
	 * @param missionRequests
	 * @returns
	 */
	deletePrestations(prestations: Prestation[]): Observable<void> {
		const httpOptions = {
			headers: new HttpHeaders({ 'Content-Type': 'application/json' }),
			body: prestations.map((e) => e.id)
		};
		return this.genericCrudService.genericDeleteAPIDataByID(
			`${this.appConstants.prestationUrl}`,
			`deletePrestation`,
			httpOptions
		);
	}
}
